angular.module('dentalLinks')
    .controller('StatusSelectorController', ['$scope', 'Referral', 'Notification', 'referralColorClasses',
        function ($scope, Referral, Notification, referralColorClasses) {
            $scope.allStatuses = [
                {key: 'active'}, 
                {key: 'scheduled'}, 
                {key: 'completed'}
            ];
            $scope.referralColorClasses = referralColorClasses;

            $scope.isReadOnly = function(status) {
                return !$scope.allStatuses
                    .map(function(s) {return s.key;})
                    .includes(status);
            }

            $scope.$watch('referral.status', function(newValue, oldValue) {

                if (oldValue && newValue) {
                    // todo: make apropriate call to backend to save status and process notifications
                    // todo: display progress indicator apropriately
                    console.log('saving status: ' + $scope.referral.status);

                    Referral.updateStatus({id: $scope.referral.id}, {status: $scope.referral.status},
                        function (success) {
                            Notification.success('Status was updated successfully!');
                        },
                        function (failure) {
                            Notification.error('Something went wrong while updating referral status...');
                        });
                    }
            })

        }]);
